import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightning02 = function Lightning02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.2495 2H8.494c-.1795 0-.2693 0-.3485.0273a.5.5 0 0 0-.1868.1155c-.0599.0586-.1.1389-.1803.2994l-4.2 8.4c-.1917.3834-.2875.5751-.2645.7309a.5.5 0 0 0 .208.3366C3.651 12 3.8654 12 4.294 12h6.2056l-3 10 12.193-12.6447c.4114-.4266.6171-.6399.6291-.8224a.5.5 0 0 0-.1763-.4149C20.0057 8 19.7094 8 19.1167 8h-7.1172z"
    })
  }));
};
export default Lightning02;